export default __webpack_public_path__ + "static/mtec-3af3aa5b91ef63d9209be6e698d7fb44.png";